var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnsubscribe = function SvgUnsubscribe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "unsubscribe_svg__a",
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h50v50H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#unsubscribe_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E91212",
    d: "M25.001 27.083 8.335 16.666V37.5H25q0 1.093.157 2.109.156 1.016.468 2.057H8.335q-1.719 0-2.943-1.224T4.168 37.5v-25q0-1.719 1.224-2.943t2.943-1.224h33.333q1.719 0 2.943 1.224t1.224 2.943v11.875a12 12 0 0 0-2.006-.782 15.5 15.5 0 0 0-2.161-.468v-6.459zm0-4.167L41.668 12.5H8.335zm14.584 25q-4.323 0-7.37-3.046-3.047-3.047-3.047-7.37t3.047-7.37 7.37-3.047 7.37 3.047Q50 33.177 50 37.5t-3.047 7.37q-3.045 3.046-7.37 3.046m-6.25-9.375h12.5v-2.083h-12.5z"
  }))));
};
export default SvgUnsubscribe;